import UPButton from 'components/button';
import { UPTanStackTableColumn } from 'components/tanstack-table';
import { TFunction } from 'i18next';
import {
  FEATURE_ACCESS__COMPANY,
  FEATURE_ACCESS__DISABLED,
  FEATURE_ACCESS__ENABLED,
  GENERAL__EDIT,
} from 'translations/constants';
import { FEATURE_LABEL_KEYS, FEATURES } from './constants';
import { StatusText } from './styles';
import { IFeatureAccessRow } from './utils';

export const buildFeatureAccessColumns = (
  t: TFunction,
  onEdit: (row: IFeatureAccessRow) => void,
): UPTanStackTableColumn<IFeatureAccessRow>[] => [
  { id: 'companyName', header: t(FEATURE_ACCESS__COMPANY), accessorKey: 'companyName' },
  ...FEATURES.map(feature => ({
    id: feature,
    header: t(FEATURE_LABEL_KEYS[feature]),
    accessorKey: feature,
    cell: ({ row }: { row: IFeatureAccessRow }) => (
      <StatusText enabled={row[feature]} data-testid={`feature-access-status-${row.companyId}-${feature}`}>
        {t(row[feature] ? FEATURE_ACCESS__ENABLED : FEATURE_ACCESS__DISABLED)}
      </StatusText>
    ),
  })),
  {
    id: 'edit',
    header: '',
    enableSorting: false,
    align: 'right',
    cell: ({ row }) => (
      <UPButton
        text={t(GENERAL__EDIT)}
        outlined
        onClick={() => onEdit(row)}
        testId={`feature-access-edit-${row.companyId}`}
      />
    ),
  },
];
